import Grid from '@mui/material/Grid2';
import { Link } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CircularProgress from '@mui/material/CircularProgress';

import { IAsyncStatus } from "../../Async/types";

import uiStyles from "../UI.module.css";


interface AsyncStatusProps {
    action: IAsyncStatus<any, any>,
    children?: React.ReactNode,
    showChildrenWhenComplete?: boolean
    showChildrenWhenErrored?: boolean
    getErrorMessage?: (error: any) => string,
    busyLabel?: string,
    retry?: () => void,
    retryLabel?: string
}

const AsyncStatus = (props: AsyncStatusProps) => {

    const showChildren = 
        !!props.children 
        && ((props.action.isComplete && props.showChildrenWhenComplete) || (props.action.hasError && props.showChildrenWhenErrored) || (!props.action.isComplete && !props.action.hasError && !props.action.isBusy));

    const defaultGetErrorMessage = (error: any) => { return error.toString(); };
    const getErrorMessage = props.getErrorMessage ?? defaultGetErrorMessage;

    return (
        <>
            {showChildren && props.children}
            {props.action.hasError && 
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    title={props.busyLabel}
                >
                    <Grid><ErrorOutlineIcon className={uiStyles.error_icon} fontSize="large"/></Grid>
                    <Grid className={uiStyles.error_text}>{getErrorMessage(props.action.error ?? 'Unknown Error')}</Grid>
                    {!!props.retry && <Grid><Link onClick={props.retry}>{props.retryLabel ?? 'Retry'}</Link></Grid>}
                </Grid>
            }
            {props.action.isBusy && 
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    title={props.busyLabel}
                >
                    <Grid><CircularProgress title={props.busyLabel} /></Grid>
                    {!!props.busyLabel && <Grid>{props.busyLabel ?? ''}</Grid>}
                </Grid>
            }
        </>
    );

}

export default AsyncStatus;